import hotel1 from './img/hotel1.jpg'
import hotel2 from './img/hotel2.jpg'
import venice from './img/venice.jpg'
export const CarouselImage = [
  {
    image: venice,
    tittle: 'Venice resort'
  },
  {
    image: hotel1,
   
  },
  {
    image: hotel2,
   
  },
]